import * as React from 'react';
import { useTranslation } from 'react-i18next';
import SwipableViews from 'react-swipeable-views';
import Paper from '@mui/material/Paper';
import { useTheme } from '../../../theme';
import { Locale } from '../../../types';
import { useMemo } from 'react';
import FareCode from '../FareCode/FareCode';
import { Tabs } from '@shared/ui/Tabs';
import { textIsLink } from '../../utils';
import { SafeHtml } from '@shared/ui';
const FareConditions = ({ onLangChange, showTranslateTab, fareRulesBySegmentsPassengersMap, tabsSegments, selectLang, setSegment, segment, selectedLang, fareRules }) => {
    var _a;
    const { FareConditions: css } = useTheme('FareConditions');
    const { t } = useTranslation('FareConditions');
    const handleLangChange = lang => {
        if (lang === selectedLang) {
            return;
        }
        onLangChange(lang);
        selectLang(lang);
    };
    const fareRulesSuccessfullyParsed = useMemo(() => Object.keys(fareRulesBySegmentsPassengersMap).length > 0, [
        fareRulesBySegmentsPassengersMap
    ]);
    const ruleTextRender = (text, index) => {
        return (React.createElement("div", { key: index }, textIsLink(text) ? (React.createElement("a", { href: text, target: "_blank" }, t('See more details on this page'))) : (React.createElement(SafeHtml, { tag: "pre", html: text }))));
    };
    const languages = [
        { locale: Locale.English, label: t('Original') },
        { locale: Locale.Russian, label: t('Translate to russian*') }
    ];
    return (React.createElement(Paper, { className: css.paperRoot },
        React.createElement("div", { className: css.title }, t('Fare conditions')),
        fareRulesSuccessfullyParsed && (React.createElement("div", { className: css.tabs__wrapper },
            React.createElement(Tabs, { classes: { tabs: css.tabs__segments, tab: css.tab }, tabs: tabsSegments.map(tab => ({ label: tab.title })), active: tabsSegments.findIndex(tab => tab.id === segment), onChange: index => {
                    setSegment(tabsSegments[index].id);
                } }),
            showTranslateTab && (React.createElement(Tabs, { classes: { tabs: css.tabs__languages, tab: css.tab }, tabs: languages.map(language => ({ label: language.label })), active: languages.findIndex(lang => lang.locale === selectedLang), onChange: index => {
                    handleLangChange(languages[index].locale);
                } })))),
        React.createElement(React.Fragment, null,
            React.createElement(SwipableViews, { index: Object.keys(fareRulesBySegmentsPassengersMap).indexOf(segment), onChangeIndex: index => {
                    setSegment(Object.keys(fareRulesBySegmentsPassengersMap)[index]);
                } }, Object.keys(fareRulesBySegmentsPassengersMap).map(key => {
                var _a, _b, _c;
                return (React.createElement("div", { key: key, className: css.fareConditionsContent },
                    React.createElement("div", null,
                        React.createElement("pre", null, segment && (React.createElement(FareCode, { passengersRules: fareRulesBySegmentsPassengersMap[segment] }))),
                        segment &&
                            ((_c = (_b = (_a = fareRulesBySegmentsPassengersMap[segment]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.rules) === null || _c === void 0 ? void 0 : _c.map((rule, index) => ruleTextRender(rule.text, index))))));
            })),
            !fareRulesSuccessfullyParsed && (React.createElement("div", { className: css.fareConditionsContent },
                React.createElement("div", null, (_a = fareRules.FareRules.rulesForSegments) === null || _a === void 0 ? void 0 : _a.map(rule => rule.rules.map((rule, index) => ruleTextRender(rule.text, index)))))))));
};
export default FareConditions;
